import { apiCall } from "../configs/axiosConfigs";
const BASE_URL = `/ecommerce/auth`;

const withQuery = (base, params) => {
  if (!params) return base;
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join("&");
  return qs ? `${base}?${qs}` : base;
};

export const authApi = {
  async Auth(payload) {
    return apiCall({
      url: `${BASE_URL}/auth`,
      method: "POST",
      data: payload
    });
  },
  async ValidateAcount(payload) {
    return apiCall({
      url: `${BASE_URL}/validateAcount`,
      method: "POST",
      data: payload
    });
  },
  async Create(payload) {
    return apiCall({
      url: `${BASE_URL}/create`,
      method: "POST",
      data: payload
    });
  },
  async ResendValidationEmail(payload) {
    return apiCall({
      url: `${BASE_URL}/resendValidationEmail`,
      method: "POST",
      data: payload
    });
  }
};

export const urlMakePageFetcherAuth = {
  url: "/ecommerce/Auth/Auth",
  method: "GET"
};

export { withQuery };
